import React, { useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import TextPopup from 'apps/auth/components/sharedComponents/popups/TextPopup';
import { MEXICO, PHILIPPINES, VIETNAM } from 'apps/auth/constants/WellKnownCountries';
import { useThemeDetector } from 'apps/auth/hooks/theme';
import { useCountryMobileMask } from 'apps/auth/hooks/useCountryMobileMask';
import pallets from 'apps/auth/theme/pallets';

export const InfoIcon = styled.span`
    cursor: pointer;
    display: inline-flex;
    margin-left: 8px;
`;

const GaRecipientDetails = (props) => {
    const popupRef = useRef(null);
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor, failedCheque } = props.options;
    const { theme } = useThemeDetector();
    const { defaultMask, masks, isReady, isMaskReadyForIso2 } = useCountryMobileMask(item.toCountryISO.toLowerCase());
    const checkStatusFailedColor = theme === 'dark' ? pallets.dark.grey_40_lc : pallets.light.grey_40_lc;
    const checkStatusSuccessColor = theme === 'dark' ? pallets.dark.black : pallets.light.black;

    return (
        <>
            {(mobileInfo.extraFields?.Recipient || mobileInfo.extraFields?.Delivery || mobileInfo.extraFields?.Bank) && (
                <>
                    <Separator marginTop="48px" marginBottom="48px" />
                    <TableContainer>
                        {mobileInfo.extraFields?.Recipient && (
                            <TableRow title={props.chequeRecipientHeader} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Recipient}
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.mobileNumber && (
                            <TableRow title={props.chequeMobilePhoneHeader} textColor={textColor} titleColor={titleColor}>
                                {isReady && isMaskReadyForIso2 && (
                                    <PhoneInput
                                        specialLabel={''}
                                        value={mobileInfo.extraFields.mobileNumber}
                                        defaultMask={defaultMask}
                                        masks={masks}
                                        disableDropdown={true}
                                        inputProps={{ readOnly: true }}
                                        inputStyle={{
                                            fontSize: 'inherit',
                                            lineHeight: 'inherit',
                                            fontFamily: 'inherit',
                                            background: 'inherit',
                                            border: 'none',
                                            color: failedCheque ? checkStatusFailedColor : checkStatusSuccessColor,
                                        }}
                                    />
                                )}
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.Delivery && (
                            <TableRow title={props.chequeDeliveryHeader} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Delivery}
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.Bank && (
                            <TableRow title={props.chequeBlockBankHeader} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Bank}
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.accountBankName && (
                            <TableRow
                                title={item.isToCash && item.toCountryId === VIETNAM ? props.chequeBlockBankForPickupHeader : props.chequeBlockPickupHeader}
                                textColor={textColor}
                                titleColor={titleColor}
                            >
                                <Row flex align="center">
                                    {mobileInfo.extraFields.accountBankName}
                                    {(item.toCountryId === PHILIPPINES || item.toCountryId === MEXICO) && (
                                        <InfoIcon
                                            onClick={() => {
                                                popupRef.current?.open(
                                                    <TextPopup
                                                        text={
                                                            item.toCountryId === MEXICO
                                                                ? props.chequeBlockPickupInfoMexico
                                                                : props.chequeBlockPickupInfoPhilippines
                                                        }
                                                        buttonText={props.gotItButton}
                                                        popupRef={popupRef}
                                                    />,
                                                );
                                            }}
                                        >
                                            <Icon name="info-rounded" color={textColor} />
                                        </InfoIcon>
                                    )}
                                </Row>
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.Address && item.toHomeDelivery && (
                            <TableRow title={props.chequeBlockAddress} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Address}
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.Provider && item.toIterac && (
                            <TableRow title={props.chequeBlockProviderHeader} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Provider}
                            </TableRow>
                        )}
                    </TableContainer>
                </>
            )}
            <PopupNew ref={popupRef} />
        </>
    );
};
const mapStateToProps = (state) => ({
    chequeDeliveryHeader: state.messages.pageMessages.chequeDeliveryHeader,
    chequeMobilePhoneHeader: state.messages.pageMessages.chequeMobilePhoneHeader,
    chequeRecipientHeader: state.messages.pageMessages.chequeRecipientHeader,
    chequeBlockProviderHeader: state.messages.pageMessages.chequeBlockProviderHeader,
    chequeBlockBankHeader: state.messages.pageMessages.chequeBlockBankHeader,
    chequeBlockBankForPickupHeader: state.messages.pageMessages.chequeBlockBankForPickupHeader,
    chequeBlockAddress: state.messages.pageMessages.chequeBlockAddress,
    chequeBlockPickupHeader: state.messages.pageMessages.chequeBlockPickupHeader,
    gotItButton: state.messages.pageMessages.gotIt,
    chequeBlockPickupInfoMexico: state.messages.pageMessages.infoMexicoCashPickup,
    chequeBlockPickupInfoPhilippines: state.messages.pageMessages.infoPhilippinesCashPickup,
});

export default connect(mapStateToProps, null)(GaRecipientDetails);
